//@ts-nocheck
import _ from 'lodash';

export default (tiles) =>
  _.uniq(_.reduce(tiles, (acc, tile) => [...acc, tile.content.type], []));
